export default __webpack_public_path__ + "static/quote-1-26760f6a06e5c1eb86c0ad3be78cff15.mp3";